module.exports = __webpack_public_path__ + "img/logo-category.ad5a4f2b.svg";